import { ToasterService } from 'angular2-toaster';
import { ErrorDialogComponent } from './../../components/dialog/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from './../../components/dialog/success-dialog/success-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { PadraoService } from 'src/app/service/padrao/padrao.service';
import { ConsultaCepService } from 'src/app/service/consulta-cep/consulta-cep.service';
import { MensagemDialogComponent } from 'src/app/components/dialog/mensagem-dialog/mensagem-dialog.component';
import { AbrirChamadoDTO } from '../../components/transferobjects/abertura-chamado/AbrirChamadoDTO';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MatDialogConfig } from '@angular/material/dialog';
import { ThemePalette } from '@angular/material';
import { isValidCpf } from 'src/app/utils/shared/cpfValidator';
import { environment } from "../../../environments/environment";
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-chamado-advogado',
  templateUrl: './chamado-advogado.component.html',
  styleUrls: ['./chamado-advogado.component.css'],
  providers: [PadraoService, MatDialog],
  entryComponents: [SuccessDialogComponent]
})

export class ChamadoAdvogadoComponent implements OnInit {
  @BlockUI() loading: NgBlockUI;

  @ViewChild('arquivo')
  formDeAnexos: ElementRef;

  recaptcha: ReCaptchaV3Service;

  chamadoDados: AbrirChamadoDTO;
  chamadoAberto: String;
  anexos: any[] = [];
  anexosStage: any[] = [];
  arquivo: File;
  extensaoDeAnexo: string;
  element: HTMLElement;
  inputAnexo: HTMLInputElement;
  unidadesFederativas: string[] = [
    'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
    'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN',
    'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'
  ];

  count = 0;

  registerForm: FormGroup;
  anexoForm: FormGroup;

  submitted = false;
  telMask: string;
  dataNascimentoMask: string;
  onLoad = false;
  progresso: 0;

  // Declarações de mensagens
  msgNomeAnexoErroAnterior: String;
  msgErroAnexoAnterior: String;
  imgAnexoErro: any;

  msgErroAnexo: String;
  msgNomeAnexoErro: String;
  imgAnexoErroAnterior: any;

  nomeAnexoErro: String;
  nomeAnexoErroAnterior: String;

  resposta: any;
  valorDialog: any;
  prod: any;

  tamanhoPermitido: any = 19999854; //20971520;
  tamanhoLido = 0;
  converterMbInBytes(valor: any) {
    valor = Math.round((valor / 1024) / 1024);
    return valor
  }

  mode: String = 'determinate';
  color: ThemePalette = 'primary';
  value = 0;   // 20000000
  bufferValue = ((20479854 * (0.0000010)) * 5); //20971520

  map = new Map();

  counter = 1;

  progressBar: any = 0;

  valorInput: any;

  constructor(private formBuilder: FormBuilder, 
              private padraoService: PadraoService, 
              private dialog: MatDialog, 
              private toast: ToasterService,
              private consultaCepService: ConsultaCepService
              ) { }

  nomeSistemas: any = [
    { id: 'PJE 1º GRAU', valor: 'PJE 1º GRAU' },
    { id: 'PJE 2º GRAU', valor: 'PJE 2º GRAU' },
    { id: 'SAJ 1º GRAU', valor: 'SAJ 1º GRAU' },
    { id: 'SAJ 2º GRAU', valor: 'SAJ 2º GRAU' },
    { id: 'PROJUDI', valor: 'PROJUDI' },
    { id: 'SAIPRO', valor: 'SAIPRO' }
  ];

  nomeServicos: any = [
    { id: 'ALTERAÇÃO', valor: 'ALTERAÇÃO' },
    { id: 'CADASTRO', valor: 'CADASTRO' },
    { id: 'ERRO', valor: 'ERRO' },
    { id: 'INFORMAÇÃO', valor: 'INFORMAÇÃO' }
  ];

  ConvertToLower(evt) {
    console.log(evt)
  }

  onSubmit() {
    const dataNascimento = new Date(this.registerForm.controls.dataNascimento.value);

    function pad(number) {
        return number < 10 ? '0' + number : number;
    }
    const formattedDate = pad(dataNascimento.getDate()) + '/' + pad(dataNascimento.getMonth() + 1) + '/' + dataNascimento.getFullYear();    
    
    this.chamadoDados.cr.category.id = environment.idcategoriaAdvogadoDelegatario;
    this.chamadoDados.cr.customer.name = '';
    this.chamadoDados.cr.description = this.registerForm.controls.detalhe.value + '\n\nDADOS SOLICITAÇÃO' 
      +'\n\n || ' + 'Nome completo: ' + this.registerForm.controls.nomeCompleto.value
      + '\n\n || '
      + 'CPF: ' + this.registerForm.controls.numeroCpf.value
      + '\n\n || '
      +  'Data de Nascimento: ' + formattedDate
      + '\n\n || '
      + 'RG: ' + this.registerForm.controls.numeroRg.value
      + '\n\n || '
      + 'Órgão expedidor: ' + this.registerForm.controls.orgaoExpedidor.value        
      + '\n\n || ' 
      + 'UF do órgão expedidor: ' + this.registerForm.controls.ufExpedidor.value        
      + '\n\n || '
      + 'Endereço: ' + this.registerForm.controls.logradouro.value + ', ' + this.registerForm.controls.enderecoNumero.value +',' 
      +  this.registerForm.controls.bairro.value+', '  + this.registerForm.controls.enderecoMunicipio.value+', '  
      +  this.registerForm.controls.uf.value + '\n\n || '
      + 'Nome do sistema: ' + this.registerForm.controls.nomeSistema.value
      + '\n\n || '
      + 'Nome do serviço: ' + this.registerForm.controls.nomeServico.value
      + '\n\n || '
      + 'Numero do Processo: ' + this.registerForm.controls.numeroProcesso.value
      + '\n\n || '
      + 'Nome das Partes: ' + this.registerForm.controls.nomePartes.value
      + '\n\n || '
    this.chamadoDados.cr.type.REL_ATTR = '';
    this.chamadoDados.cr.z_alt_phone_number = this.registerForm.controls.numeroTelefone.value;
    this.chamadoDados.cr.cidade.id = '';
    this.chamadoDados.cr.comarca.id = '';
    this.chamadoDados.cr.lotacao.id = '';
    this.chamadoDados.cr.zs_email_preferencial = this.registerForm.controls.email.value;
    this.chamadoDados.cr.zs_oab = this.registerForm.controls.numeroOab.value + " - " + this.registerForm.controls.ufOAB.value;
    this.chamadoDados.cr.group.name = 'COATE_SD_N1';

    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    for (let i = 0; i <= this.map.size; i++) {
      this.anexos.push(this.map.get('divAnexo' + i));
    }

    this.loading.start('Aguarde um momento...');
    this.padraoService.abrirChamado(JSON.stringify(this.chamadoDados), this.anexos).subscribe(response => {
      this.chamadoAberto = response;
      this.loading.stop();
      this.abrirRespostaSucesso(response);
      this.limparForm();
    }, (error) => {
      this.loading.stop();
      this.abrirRespostaErro(error);
    });
  }

  abrirMensaagemdialog(resposta: any, titulo:any,subTitulo:any) {

    const mensagemDialog = new MatDialogConfig();
    mensagemDialog.autoFocus = true;
    mensagemDialog.disableClose = true;
    mensagemDialog.data = { valor: resposta, titulo: titulo,subTitulo:subTitulo };
    mensagemDialog.width = '550px';
    mensagemDialog.height = '350px';
    this.dialog.open(MensagemDialogComponent, mensagemDialog);
  }

  carregarEndereco(cep):void {
    var cep = cep.value.cep;


    console.log(cep);

    if(cep === '') {
      this.abrirMensaagemdialog("Insira um CEP para realizar a consulta!","Validação de Formulário","Endereço");
      return;
    }

    this.loading.start('Aguarde um momento...');
    this.consultaCepService.obterEndereco(cep).subscribe(response => {

      if(response != null && response.cep != null ) {
          this.registerForm.get('logradouro').setValue(response.logradouro);
          this.registerForm.get('enderecoMunicipio').setValue(response.localidade);
          this.registerForm.get('bairro').setValue(response.bairro);
          this.registerForm.get('uf').setValue(response.uf);
      }else{
          this.abrirMensaagemdialog("CEP: "+ cep + " não encontrado. Favor verificar!","Validação de Formulário","Endereço");
          this.registerForm.get('cep').setValue('');
          this.registerForm.get('logradouro').setValue('');
          this.registerForm.get('enderecoMunicipio').setValue('');
          this.registerForm.get('bairro').setValue('');
          this.registerForm.get('uf').setValue('');
      }
      this.loading.stop();
    }, (error) => { 
      this.loading.stop();
      this.abrirMensaagemdialog("CEP: "+ cep + " não encontrado. Favor verificar!","Validação de Formulário","Endereço");
          this.registerForm.get('cep').setValue('');
          this.registerForm.get('logradouro').setValue('');
          this.registerForm.get('enderecoMunicipio').setValue('');
          this.registerForm.get('bairro').setValue('');
          this.registerForm.get('uf').setValue('');

    });
  }

  abrirRespostaSucesso(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = '600px';
    dialogConfig.height = '380px';
    dialogConfig.panelClass = 'custom-dialog';
    this.dialog.open(SuccessDialogComponent, dialogConfig);
  }

  abrirRespostaErro(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = '600px';
    dialogConfig.height = '380px';
    this.dialog.open(ErrorDialogComponent, dialogConfig);
  }

  criarMaisUmCampoAnexo() {
    return this.formBuilder.group({
      anexo: ['']
    })
  }

  adicionarUmAnexo() {
    this.count++;
    this.counter++;
    (this.anexoForm.get('anexoItem') as FormArray).push(this.formBuilder.group({ 
      anexo: ['']
    }))

    this.anexos.push(this.formBuilder.group({ 
      anexo: ['']
    }));
  }

  removeInput(index, arquivo: any) {
    if (this.count == 0) {
      this.element = document.getElementById(index) as HTMLElement;
      this.element.hidden = true;
    }
    if (this.count > 0) {
      this.element = document.getElementById(index) as HTMLElement;
      this.element.hidden = true;
      this.count--;
    }
    this.progressBar -= (arquivo.files[0].size * 0.0000010) * 5;
    this.tamanhoLido -= arquivo.files[0].size;
    this.map.delete(index);
  }

  arrayInputs = [{ anexo: ['a', Validators.required] }, { anexo: 'b' }];

  formName = this.formBuilder.group({
    controllerArray: this.formBuilder.array([])
  })

  setArrayInputs(arrayInputs) {
    const arrayFG = arrayInputs.map(address => this.formBuilder.group(address));
    const formArray = this.formBuilder.array(arrayFG);
    this.anexoForm.setControl('anexoItem', formArray); 
  }


  ngOnInit() {

    this.chamadoDados = new AbrirChamadoDTO();
    this.anexoForm = this.formBuilder.group({
      anexoItem: this.formBuilder.array([this.criarMaisUmCampoAnexo()])
    });

    this.registerForm = this.formBuilder.group({
      nomeCompleto: ["", [Validators.required, Validators.minLength(5), Validators.maxLength(256)]],
      numeroCpf: ['', Validators.compose([Validators.required, Validators.minLength(11), isValidCpf()])],
      numeroRg: ['', Validators.compose([Validators.required, Validators.minLength(4),Validators.maxLength(11), Validators.pattern(/^[0-9.-]*$/)])],
      orgaoExpedidor: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(6), Validators.pattern('^[A-Za-zÀ-ÿ -]+$')]],
      ufExpedidor: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
      email: ['',  Validators.compose([Validators.required, Validators.email])],
      numeroOab: ['', Validators.compose([Validators.required, Validators.maxLength(13)])],
      ufOAB: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
      numeroTelefone: ['', [Validators.required, Validators.minLength(10)]],
      dataNascimento: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
      cep: ['', [Validators.required]],
      logradouro:['',[Validators.required, Validators.maxLength(80)]],
      bairro:['',[Validators.required, Validators.minLength(2), Validators.maxLength(80)]],
      enderecoNumero: ['', [Validators.required, Validators.maxLength(5)]],
      enderecoMunicipio: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(80)]],
      uf: ['', [Validators.required, Validators.maxLength(2)]],
      nomeSistema: ['', Validators.required],
      nomeServico: ['', Validators.required],
      instancia: [''],
      numeroProcesso: [''],
      nomePartes: [''],
      detalhe: ['', [Validators.required, Validators.minLength(25)]]
    });

    this.registerForm.get('numeroTelefone').valueChanges.map(valor => valor).subscribe(length => {
      if (length < 11) {
        this.telMask = '(00) 0000-00000';
      } else {
        this.telMask = '(00) 00000-0000';
      }
    });
    this.registerForm.get('dataNascimento').valueChanges.map(valor => valor).subscribe(length => {
      if (length < 10) {
        this.dataNascimentoMask = '00/00/0000';
      } else {
        this.dataNascimentoMask = '00/00/0000';
      }
    });

    this.registerForm.get('email').valueChanges.subscribe(event => {
      this.registerForm.get('email').setValue(event.toLowerCase(), {emitEvent: false});
   });

   this.anexos.push(this.formBuilder.group({ anexo: ['']}));

  }

  eventoAdicionarAnexo(): any {
     if(this.count === 0) {
      this.adicionarUmAnexo();
      this.count -= 1;
    } 
    return this.count;
  }
  /* início evento para pegar o endereço do arquivo anexado em - tela erro */

  eventoLeituraArquivo(event: any, id: any): any {
    this.lerArquivo(event.target, id);
    return this.arquivo;
  }


  /* Ler o aquivo anexado */
  lerArquivo(anexo: any, id: any) {
    const anexoExtensao: File = anexo.files[0];
    this.map.set('divAnexo'+id, anexo.files[0]);
    const extensoesPermitidas = ['.pdf', '.jpg', '.jpeg', '.png'];
    let nomeArquivo: string;
    nomeArquivo = anexoExtensao.name.toLowerCase();

    this.valorInput = (document.getElementById('valorAnexo'+id));
    this.valorInput.innerHTML = nomeArquivo;    
    this.tamanhoLido += anexo.files[0].size; 
    this.extensaoDeAnexo = nomeArquivo.substring(nomeArquivo.lastIndexOf('.'));
    
    if (extensoesPermitidas.indexOf(this.extensaoDeAnexo) > -1) {
      if (this.tamanhoLido <  this.tamanhoPermitido) {
        this.msgNomeAnexoErroAnterior = nomeArquivo;
        this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
        this.inputAnexo = (document.getElementById('anexoInput'+id) as HTMLInputElement);
        this.inputAnexo.disabled = true;
      } else {
        this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
        this.removeInput('divAnexo'+id, anexo);
        this.toast.pop('warning', 'Soma total de arquivos excedida.');
        this.adicionarUmAnexo();
      }
    }  else {
      this.toast.pop('warning', 'Só é permitida a anexação de arquivos com as seguintes extensões: PDF, JPG, JPEG, PNG.');
      if(this.count===0) {
        this.removeInput('divAnexo'+id, anexo);
        this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
        this.adicionarUmAnexo();
    } else if (this.count > 0) {
        this.removeInput('divAnexo'+id, anexo);
        this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
        this.adicionarUmAnexo();
      }
    }
  }

  get f() {
    return this.registerForm.controls;
  }
  
  limparForm() {
    this.ngOnInit();
    this.progressBar = 0;
    this.tamanhoLido = 0;
    this.count = 0;
    this.counter = 1;
    this.anexos = [];
  }

  public removerEspaco(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => formGroup.get(key).setValue(formGroup.get(key).value.trim()));
  }

}
